<template>
  <section>
    <ul class="c-accordion ul-reset">
      <li
        v-for="(module, index) of curriculum.modules"
        :key="module.id"
        class="c-accordion__item c-module"
      >
        <input
          :id="'module-' + index"
          class="d-none"
          type="checkbox"
          :checked="isActivedModule(module)"
        >
        <label :for="'module-' + index">
          <div class="c-switcher d-flex justify-content-between">
            <div class="c-switcher__title mb-0 white w-bold d-flex">
              <div class="c-module__progress-container">
                <ProgressCircle :percentage="getModulePercentage(module)"></ProgressCircle>
              </div>
              <span class="flex-grow-1">{{module.title}}</span>
            </div>
            <div class="c-switcher__arrow d-flex align-items-center ms-2">
              <i class="iconf-arrow-down d-flex align-items-center"></i>
            </div>
          </div>
        </label>
        <div class="c-body">
          <ul class="c-module__lections">
            <li
              v-for="lection of module.lessons"
              :key="lection.id"
              class="c-module__lection"
              :class="[loadingClass, isActivedLection(module, lection),
                {'completed' : lection.completed}]"
            >
              <a
                v-if="isBlockedLection(lection) || (!lection.preview && !course.enroll)"
                class="d-flex justify-content-between"
                :class="{'blocked' : (!lection.preview && !course.enroll)}"
                href="#"
                @click.prevent="openBlockecLection()"
              >
                <p class="c-title mb-0 w-medium d-flex align-items-center">
                  {{lection.title}}
                  <i class="iconf-lock ms-2 d-flex align-items-center"></i>
                </p>
                <span v-if="lection.time" class="d-flex align-items-center medium-gray fs-14">
                  <i class="iconf-clock d-flex align-items-center me-1"></i>
                  <span
                    v-if="getLectionTime('s', lection)"
                    class="number"
                  >
                    {{getLectionTime('s', lection)}}m
                  </span>
                  <span
                    v-if="getLectionTime('m', lection)"
                    class="number"
                  >
                    {{getLectionTime('m', lection)}}s
                  </span>
                </span>
              </a>
              <router-link
                v-else-if="lection.preview || course.enroll"
                :to="`/curso/${current.course}/lecciones/${module.number}/${lection.slug}/`"
                class="d-flex justify-content-between"
              >
                <p class="c-title mb-0 w-medium d-flex align-items-center">
                  {{lection.title}}
                </p>
                <span v-if="lection.time" class="d-flex align-items-center medium-gray fs-14">
                  <i class="iconf-clock d-flex align-items-center me-1"></i>
                  <span
                    v-if="getLectionTime('s', lection)"
                    class="number"
                  >
                    {{getLectionTime('s', lection)}}m
                  </span>
                  <span
                    v-if="getLectionTime('m', lection)"
                    class="number"
                  >
                    {{getLectionTime('m', lection)}}s
                  </span>
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <router-link
      v-if="homeworksEnabled"
      :to="getHomeworkRoute(homework)"
      :class="['c-module c-module--homework d-block mt-3', {'active': isHomeworkActive(homework)}]">
      <div class="d-flex justify-content-between">
        <p class="c-name mb-0 w-bold">
          <ProgressCircle percentage="0"></ProgressCircle>
          <span>Proyecto final</span>
        </p>
        <i class="iconf-task d-flex align-items-center medium-gray"></i>
      </div>
    </router-link>
    <button
      v-if="examEnabled"
      @click="goToExam"
      :id="examButtonId"
      :class="['c-module c-module--exam mt-3', {'c-button--disabled-black': !course.exam_access}]">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center w-bold">
          <i class="iconf-task d-flex align-items-center fs-21 me-2"></i>
          {{ examResult.approved ? 'Ver certificado' : 'Presentar examen' }}
        </div>
        <i class="iconf-right-arrow d-flex align-items-center"></i>
      </div>
    </button>
  </section>
</template>

<script>
/* eslint-disable */
import ProgressCircle from './progress/ProgressCircle.vue'

export default {
  data() {
    return {
      arcux: window.arcux,
      current: {
        course: this.$route.params.course_id,
        module: this.$route.params.module,
        lection: this.$route.params.lection_slug,
      },
      examResult: false,
    }
  },
  props: ['user', 'content', 'course', 'curriculum', 'isTeacher'],
  components: {
    ProgressCircle,
  },
  computed: {
    loadingClass: function() {
      return (this.content.loading) ? 'loading' : '';
    },
    homework: function() {
      return this.curriculum.homeworks[0]
    },
    homeworksEnabled: function() {
      return this.course.enroll && this.curriculum.homeworks.length > 0 && ((this.course.progress && this.course.certificate) || this.isTeacher)
    },
    exam: function() {
      return this.curriculum.exam;
    },
    examEnabled: function() {
      return this.course.enroll && this.course.certificate && this.exam;
    },
    examButtonId: function() {
      return (!this.course.exam_access) ? 'aulavirtual-temario-presentarexamen-prueba1-disablebutton-1' : 'aulavirtual-temario-presentarexamen-button-1';
    },

    isBlockedCourse() {
      return (this.course?.enroll?.data?.trial?.watched_lessons + 1) >= 20;
    },
  },
  watch: {
    $route (to, from){
      this.current.module = this.$route.params.module;
      this.current.lection = this.$route.params.lection_slug;
    },
    user() {
      this.getResultExam();
    },
  },
  mounted() {
    if (this.user) this.getResultExam();
  },
  methods: {
    getModulePercentage: function(module) {
      let completedLections = module.lessons.filter(lec => lec.completed).length;

      return (module.completed) ? 100 : completedLections*100/module.total_lessons;
    },
    getLectionTime: function(level, lection) {
      return (level == 's') ? Number(lection.time.split(':')[1]) : Number(lection.time.split(':')[2]);
    },
    getHomeworkRoute(homework) {
      return `/curso/${ this.current.course }/lecciones/${ homework.module }/${ homework.slug }/`
    },
    isActivedModule: function(module) {
      if (this.content.body && (this.content.body.type == 'text' || this.content.body.type == 'video')) {
        return this.current.module == module.number;
      }else
        return false;
    },
    isActivedLection: function(module, lection){
      return (this.current.lection == lection.slug && this.current.module == lection.module && (lection.preview || this.course.enroll)) ? 'active' : '';
    },
    isHomeworkActive(homework) {
      return this.current.lection == homework.slug && this.current.module == homework.module && this.course.enroll ? 'active' : ''
    },
    isBlockedLection(lection) {
      return this.isBlockedCourse && !lection.completed;
    },

    openBlockecLection() {
      if (this.isBlockedCourse) {
        this.$bvModal.show('limitedPremiumModal');
      }
    },

    getResultExam: function() {
      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/solved-exams?examId=${this.exam.id}`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.examResult = data;
      })
      .catch(err => {
        throw err;
      })
    },
    goToExam: function() {
      const url = this.exam.url.split('/curso/');

      if (this.course.exam_access) {
        if (this.course.access) {
          if (this.course.access.plan !== '24 horas') {
            this.goToExamFinal(url);
          } else {
            this.$bvModal.show('modalSuscription');
          }
        } else {
          this.goToExamFinal(url);
        }
      } else {
        this.$bvModal.show('modalSuscription');
      }
    },
    goToExamFinal(url) {
      const examURL = (this.$route.params.speciality_id) ? `${url[0]}/curso/${this.$route.params.speciality_id}/${url[1]}` : this.exam.url;

      if (
        (this.course.progress && Number(this.course.progress.percentage) >= 95)
        || this.user.roles.includes('administrator')
        || this.user.roles.includes('core')
      ) {
        this.$router.push(examURL);
      } else {
        this.$bvModal.show('modalExam');
      }
    },
  },
}
</script>
